import { render, staticRenderFns } from "./detaildenda.vue?vue&type=template&id=7f532b93&"
import script from "./detaildenda.vue?vue&type=script&lang=js&"
export * from "./detaildenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports